import { Box, Button, Stack } from "@mui/material";

import { useDisclosure } from "hooks";
import { isDeadQuote } from "utils";

import { QuoteDetail } from "./components/QuoteDetail";
import { QuoteHistory } from "./components/QuoteHistory";
import { QuoteInteraction } from "./components/QuoteInteraction";

interface Props {
  quote: CondensedQuote | ShipperCondensedQuote;
  // Whether other quotes exist on the same shipment — a dead quote recedes
  // into a muted block whenever it's not the only quote on the shipment.
  hasMultipleQuotes?: boolean;
}

export function ShipmentQuote(props: Props) {
  const { quote, hasMultipleQuotes = false } = props;
  const { isOpen, onClose, onOpen } = useDisclosure(false);

  const historyButton = (
    <Button variant="text" onClick={isOpen ? onClose : onOpen}>
      {isOpen ? "Hide History" : "View History"}
    </Button>
  );

  const isMuted = hasMultipleQuotes && isDeadQuote(quote.internal_state);

  return (
    <Box
      sx={
        isMuted
          ? {
              backgroundColor: "grey.50",
              borderRadius: 1,
              px: 1.5,
            }
          : undefined
      }
    >
      <Stack py={2} direction="column">
        <QuoteDetail quote={quote} />
        <QuoteInteraction
          viewQuoteHistory={historyButton}
          actions={quote.actions}
          quote={quote}
        />
        {isOpen && <QuoteHistory quoteId={quote.quote} />}
      </Stack>
    </Box>
  );
}
